import React from "react";
import IElearningPage from "../../../types/IElearningPage";
import { Box, Grid } from "@mui/material";
import MediaDisplay from "../../../components/MediaDisplay";

export default function PageRightLayout({ page }: { page: IElearningPage }) {
  return (
    <Box p={2}>
      <Grid container spacing={2}>
        <Grid item xs={6} dangerouslySetInnerHTML={{ __html: page.content }} />
        {page.media && (
          <Grid item xs={6}>
            <MediaDisplay media={page.media} />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
